<template>
<content-div>
	<div class="contArea">
		<!-- tabType1 -->
		<div class="tabType2">
			<ul class="col3">
			<li v-for="(tab, index) in tabs" :key="index" :class="{'on': selected.tabCont === index }">
				<a @click="changeTab(index)"><span>{{tab.title}}</span></a>
			</li>
			</ul>
		</div>

		<div class="tabCont">
			<section v-if="selected.tabCont === 0">

				<div class="contArea" style="margin-bottom:40px;">
					<div class="sub_copy">
						<h3 class="sub_copy_title" style="font-weight: 700; font-size:15px; line-height: 22px; margin-top: 0px;">
							{{ howToUse.category }}
						</h3>
					</div>
					
					<ul class="prodWrap">
						<li v-for="(ctt, idx) in howToUse.content" :key="idx" style="padding: 10px 10px;"
						:style="idx < howToUse.content.length-1 ? 'border-bottom: 1px solid #DDDDDD;' : ''">
							<img :src="`${$store.state.dir}images/guide/${ctt.icon}.png`" alt="" style="width: 28px; height: 28px;">
							<dl>
								<dt v-if="ctt.title" style="font-size: 14px; line-height: 20px; font-weight: 400;">
									{{(howToUse.content.length > 1 ? idx+1 + '.' : '') + ctt.title }}
								</dt>
								<dd v-if="ctt.datas && typeof ctt.datas == 'string'" style="color: #4D4D4D;">{{ ctt.datas }}</dd>
								<dd v-else-if="ctt.datas && typeof ctt.datas == 'object'" v-for="(data, key) in ctt.datas" :key="key">
									<span style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;" :style="data.style ? data.style : ''">
										{{ data.symbol + (data.symbol ? ' ' : '') + data.detail }}
									</span>
									<br v-if="key < ctt.datas.length">
								</dd>

								<dd v-if="ctt.html" style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;" v-html="ctt.html"></dd>
								
								<div v-if="idx === (howToUse.content.length-1) " class="sub_copy" style="margin-top:20px;">
									<span style="font-size: 12px; line-height: 18px; font-weight: 400;">{{$store.state.insuranceName}} 고객 센터</span>
									<p style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;">
										<span>※ 전화번호 : {{envServer.tell}} / {{envServer.tell2}}</span><br>
										<span>※ 운영시간 : 월 ~ 금: 9시-18시</span><br>
										<span>
											※ 사전 승인 절차에서 {{$store.state.insuranceName}} 사용이 반려될 수 있습니다.<br>
											※ 보다 자세한 사항은 서비스 약관을 통해 확인하실 수 있습니다.<br>
											※ {{envServer.email}} 해당 이메일 주소로 제출해 주세요.
										</span>
									</p>
								</div>
							</dl>
						</li>
					</ul>
					
				</div>
			</section>

			<section v-else-if="selected.tabCont === 1">
				<div class="contArea" style="margin-bottom:40px;">
					<div class="sub_copy">
						<h3 class="sub_copy_title" style="font-weight: 700; font-size:15px; line-height: 22px; margin-top: 0px;">
							{{ billingMethod.category }}
						</h3>
						<h4 v-if="billingMethod.categoryDetail" style="font-weight: 300; font-size:12px; line-height: 18px; color: #4D4D4D;">
							{{ billingMethod.categoryDetail }}
						</h4>
					</div>
					
					<ul class="prodWrap">
						<li v-for="(ctt, idx) in billingMethod.content" :key="idx" style="padding: 10px 10px; border-bottom: 1px solid #DDDDDD;">
							<img :src="`${$store.state.dir}images/guide/${ctt.icon}.png`" alt="" style="width: 28px; height: 28px;">
							<dl>
								<dt v-if="ctt.title" style="font-size: 14px; line-height: 20px; font-weight: 400;">
									{{(billingMethod.content.length > 1 ? idx+1 + '.' : '') + ctt.title }}
								</dt>
								<dd v-if="ctt.datas && typeof ctt.datas == 'string'">{{ ctt.datas }}</dd>
								<dd v-else-if="ctt.datas && typeof ctt.datas == 'object'" v-for="(data, key) in ctt.datas" :key="key">
									<span style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;" :style="data.style ? data.style : ''">
										{{ data.symbol + (data.symbol ? ' ' : '') + data.detail }}
									</span>
									<br v-if="key < ctt.datas.length">
								</dd>

								<dd v-if="ctt.html" style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;" v-html="ctt.html"></dd>
								
								<div v-if="idx === (billingMethod.content.length-1) " class="sub_copy" style="margin-top:20px;">
									<span style="font-size: 12px; line-height: 18px; font-weight: 400;">{{$store.state.insuranceName}} 고객 센터</span>
									<p style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;">
										<span>※ 전화번호 : {{envServer.tell}} / {{envServer.tell2}}</span><br>
										<span>※ 운영시간 : 월 ~ 금: 9시-18시</span><br>
										<span>※ 이메일 주소 : {{envServer.email}}</span>
									</p>
								</div>
							</dl>
						</li>
					</ul>
				</div>
				
			</section>

			<section v-else>
				<div class="contArea">
					<div v-if="prodsUsed.items.length > 0" class="sub_copy">
						<h3 class="sub_copy_title" style="font-weight: 700; font-size:15px; line-height: 22px; margin-top: 0px;">
							{{ $store.state.insuranceName.toUpperCase() }} 사용내역
						</h3>
					</div>
					
					<ul v-if="prodsUsed.items.length > 0" class="" >
						<li class="prodWrap" v-for="(prod, idx) in prodsUsed.items" :key="idx">
							<div style="display: flex; justify-content: space-between;">
								<span style="font-weight: 300; font-size: 12px; line-height: 18px; color: #7B7B7B;">사용금액</span>
								<span style="font-weight: 300; font-size: 14px; line-height: 18.97px; color: #262626;">{{ String(Const.getPriceAddVatRound(prod.used.unit)) | currency }}원</span>
							</div>
							<div style="display: flex; justify-content: space-between;">
								<span style="font-weight: 300; font-size: 12px; line-height: 18px; color: #7B7B7B;">사용일자</span>
								<span style="font-weight: 300; font-size: 14px; line-height: 18.97px; color: #262626;">{{ prod.used.date | date }}</span>
							</div>
							<div style="display: flex; justify-content: space-between;">
								<span style="font-weight: 300; font-size: 12px; line-height: 18px; color: #7B7B7B;">사용지점</span>
								<span style="font-weight: 300; font-size: 14px; line-height: 18.97px; color: #262626;">{{ DEALER_AGENT_CDKS[prod.used.dealer_agent_cdk_slug].title }}</span>
							</div>
							<div style="width: auto; height: 45px; background: #1C69D4; margin: 10px 10px; display: flex; justify-content: center; align-items: center;">
								<a style="color: #ffffff; font-weight: 300; font-size: 15px; line-height: 16px; " @click="popupOpen(true, idx)">{{ $store.state.insuranceName }} 청구하기</a>
							</div>
						</li>
					</ul>

					<div v-else style="font-weight: 400; font-size: 15px; line-height: 20px; text-align: center; margin-top: 20px;">사용내역이 없습니다.</div>
				</div>

				<popup-full v-if="popupActivate" @close="popupOpen(false, -1)">

				<template #title>{{ $store.state.insuranceName.toUpperCase() }} 금액청구</template>

					<template #content>
					
					<div class="sub_copy">
						<h3 class="sub_copy_title" style="font-weight: 700; font-size:15px; line-height: 22px;"
						:style="(billingMethod.categoryDetail ? 'margin-bottom: unset;' : '')">
							{{ billingMethod.category }}
						</h3>
						<h4 v-if="billingMethod.categoryDetail" style="font-weight: 300; font-size:12px; line-height: 18px; color: #4D4D4D;">
							{{ billingMethod.categoryDetail }}
						</h4>
					</div>
					
					<div class="sub_copy">
						<h3 class="sub_copy_title" style="font-weight: 400; font-size:15px; line-height: 22px; color: #262626;">
							{{ $store.state.insuranceName.toUpperCase() }} 사용내역
						</h3>
						<p class="" style="font-weight: 400; font-size: 12px; line-height: 22px; color: #1C69D4;">Power Train 10,000,000원</p>
					</div>

					<ul>
						<li class="prodWrap">
							<div style="display: flex; justify-content: space-between;">
								<span style="font-weight: 300; font-size: 12px; line-height: 18px; color: #7B7B7B;">사용금액</span>
								<span v-if="item" style="font-weight: 300; font-size: 14px; line-height: 18.97px; color: #262626;">{{ String(item.price_with_vat) | currency}}원</span>
							</div>
							<div style="display: flex; justify-content: space-between;">
								<span style="font-weight: 300; font-size: 12px; line-height: 18px; color: #7B7B7B;">사용일자</span>
								<span v-if="item" style="font-weight: 300; font-size: 14px; line-height: 18.97px; color: #262626;">{{ item.date_approval | date}}</span>
							</div>
							<div style="display: flex; justify-content: space-between;">
								<span style="font-weight: 300; font-size: 12px; line-height: 18px; color: #7B7B7B;">사용지점</span>
								<span v-if="item" style="font-weight: 300; font-size: 14px; line-height: 18.97px; color: #262626;">{{item.dealer_title}}</span>
							</div>
						</li>

						<li class="prodWrap" v-for="(ctt, idx) in billingMethod.content" :key="idx">
							<img :src="`${$store.state.dir}images/guide/${ctt.icon}.png`" alt="" style="width: 28px; height: 28px;">
							<dl>
								<dt v-if="ctt.title" style="font-size: 14px; line-height: 20px; font-weight: 400;">
									{{(billingMethod.content.length > 1 ? idx+1 + '.' : '') + ctt.title }}
								</dt>
								<dd v-if="ctt.datas && typeof ctt.datas == 'string'">{{ ctt.datas }}</dd>
								<dd v-else-if="ctt.datas && typeof ctt.datas == 'object'" v-for="(data, key) in ctt.datas" :key="key">
									<span style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;" :style="data.style ? data.style : ''">
										{{ data.symbol + (data.symbol ? ' ' : '') + data.detail }}
									</span>
									<a v-if="key == 0" @click="downloadPOAPdf" style="color: #1C69D4; font-size: 10px; line-height: 18px;">(PDF다운로드)</a>
									<br v-if="key < ctt.datas.length">
								</dd>

								<dd v-if="ctt.html" style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;" v-html="ctt.html"></dd>
								
								<div v-if="idx === (billingMethod.content.length-1) " class="sub_copy" style="margin-top:20px;">
									<span style="font-size: 12px; line-height: 18px; font-weight: 400;">{{$store.state.insuranceName}} 고객 센터</span>
									<p style="font-size: 12px; line-height: 18px; font-weight: 300; color: #4D4D4D;">
										<span>※ 전화번호 : {{envServer.tell}} / {{envServer.tell2}}</span><br>
										<span>※ 운영시간 : 월 ~ 금: 9시-18시</span><br>
										<span>※ 이메일 주소 : {{envServer.email}}</span>
									</p>
								</div>
							</dl>
						</li>
					</ul>
				</template>
				</popup-full>

			</section>

		</div>
	</div>
</content-div>
</template>
	
	
<script>
import { mapState } from 'vuex';
import Const from '../../helpers/Const';
import {api} from '@/api';
import axios from 'axios';
import Format from '../../helpers/Format';

import PopupFull from '@/components/Popup/PopupFull.vue'
import ButtonAppDownload from '@/components/Button/ButtonAppDownload.vue'

export default {
	name: 'GuideWarranty',

	components: {
		PopupFull,
		ButtonAppDownload,
	},
	filters: Format,
	
	created () {
		this.getSubscs();
	},
	data() {
		return {
			onload: false,
			selected: {
				tabCont: 0,
				group: 0,
			},
			tabs: [
				{title: '이용 방법' },
				{title:'청구방법'},
				{title:'사용내역'}
			],
			Const,
			item:{
				id:0,
			},
			prodsUnused: { count: 0, items: [], },
			prodsUsed: { count: 0, items: [], },
			howToUse: {
				category:`${this.$store.state.insuranceName.toUpperCase()} 이용 방법`,
				content: [
					{icon: 'micon4', title: '차량 점검', html: 'BMW 공식 서비스 센터에 방문하여 차량을 점검 받으세요.'},
					{icon: 'micon0', title: '가견적 및 작업지시서', html: '진단기 검사 진행 후에 가견적서 및 작업지시서를 받으세요.'},
					{icon: 'micon5', title: '청구 가능 여부 확인', html: '담당 서비스 어드바이저가 사전승인절차를 통해 청구 가능 여부를 확인하여 알려드려요.'},
					{icon: 'micon6', title: '수리비용 환급', html: `차량 수리 완료 후, 서비스 센터에 비용을 지급하신 이후에 청구서류를 제출하시면,${this.$store.state.insuranceName}고객센터에서 수리비용을 환급해 드립니다.`
					},
				]
			},
			billingMethod : {
				category:`${this.$store.state.insuranceName.toUpperCase()} 금액 청구 방법`,
				categoryDetail: `${this.$store.state.insuranceName} 수리완료 후 청구 서류를 제출하시고 수리비를 환급 받으세요`,
				content: [
					{icon:'micon7', title: '청구서류'
					, datas: [
						{symbol:'-', detail: '청구 (위임장 및 동의서)'},
						{symbol:'-', detail: '신분증 사본'},
						{symbol:'-', detail: '통장사본'},
						{symbol:'-', detail: '차량등록증'},
						{symbol:'-', detail: '차량등록증'},
						{symbol:'-', detail: '자동차 검사표'},
						{symbol:'-', detail: '전면사진 (번호판 포함)'},
						{symbol:'-', detail: '차량계기판 사진 (주행거리 포함)'},
						{symbol:'-', detail: '수리 견적서 (BMW 공식 딜러 서비스 센터에서 요청)'},
						{symbol:'-', detail: '수리비 영수증 (BMW 공식 딜러 서비스 센터에서 요청)'},
						{symbol:'-', detail: '대량 부품 수리 전후 사진 (BMW 공식 딜러 서비스 센터에서 요청)'},
						{symbol:'※', detail: '단, 가견적을 통한 청구 가능여부와 실제 보상여부는 상이할 수 있으며, 보상의 세부사항은 BMW ServiceCare+ 이용약관을 따릅니다.'},
						{symbol:'※', detail: '청구 금액은 서류 검토 완료 후, 영업일 기준 7일 이내에 지급될 예정입니다.'},
						{symbol:'※', detail: `보험금 청구 문의는 ${this.$store.state.insuranceName} 고객센터로 문의 바랍니다.`},
					]}
				]
			},
			isFraction: false,
			popupActivate: false,

			subscProds: [],
			user: null,
			subscs: [],
			vehicles: [],
		}
	},

	computed:{
		...mapState({
			envServer: state => state.envServer,
			user: state => state.user,
			btnLoading: state => state.btnLoading,
			DEALER_AGENT_CDKS: (state) => {
				return state.filters.DEALER_AGENT_CDKS;
			},
		}),
	},

	methods: {
		changeTab(idx) {
			this.selected.tabCont = idx;
		},

		getSubscs() {
			// 구독해지취소신청 등 redirect 기능구현을 위해 data reset    20.03.23    sang
			this.onload = false;
			this.vehicles = [];
			this.subscs = [];

			//plus_id 가 없을경우
			if(!this.$store.state.user.vtg_id) {
				this.$store.commit('setPopup401', true);
				return;
			}

			//plus_id가 있지만 token이 존재하지 않을경우 (prime 내 미가입상태)
			if(this.$store.state.user.id == 0){
				this.onload = true;
				return;
			}
			
			const subsc_id = this.$route.query.subsc_id;
			if(subsc_id) this.getSubscProds(subsc_id);

			//this.$store.commit('setBtnLoading', true);
			// 2022-05-04 jeon
			// plus_id 암호화 데이터 전체데이터를 가져와 filter한다 오래걸린다... id변경
			// axios.get(`${api.users}/showByPlusId/${this.$store.state.user.plus_id}`)
			// axios.get(`${api.users}/${this.$store.state.user.id}`)
			// .then(({data}) => {
			// 	//const vehicle = data.data.vehicles;
			// 	const subscs = data.data.subscs;
			// 	this.user = data.data;

			// 	this.subscProds = subscs.filter((e)=>{ return (e.state == Const.SUBSC_STATE.ENABLE && e.prodTypeInsurance != null) });
				
			// 	this.onload = true;

			// 	const subsc_id = this.$route.query.subsc_id;

			// 	if(subsc_id) {
			// 		this.getSubscProds(subsc_id);
			// 	} else {
			// 		if(this.subscProds.length > 0) {
			// 			this.getSubscProds(this.subscProds[0].id);
			// 		}
			// 	}
				
			// })
			// .catch((error) => {
			// 	const errCode = error.response.status;
			// 	//401 = token X  &&  409 = 유저 X
			// 	if(errCode == 401){
			// 		this.$store.commit('setPopup401', true);
			// 		return;
			// 	} else if (errCode != 409) {
			// 		this.popupMsg = this.errorMsg(error);
			// 		this.activate = true;
			// 	}
			// 	this.onload = true;
			// })
		},

		getSubscProds(subscId) {
			if (subscId) {
				this.$store.commit('setBtnLoading', true);
				this.onload = false;
				axios.get(`${api.subscs}/showProdsInsurance/${subscId}`)
					.then(({data}) => {
						this.prodsUnused.items = data.data.able;
						this.prodsUnused.count = data.data.able.length;
						this.prodsUsed.items = data.data.disable;
						this.prodsUsed.count = data.data.disable.length;
						this.onload = true;
					})
					.catch((error) => {
					if(error.response.status == 401) {
						this.$store.commit('setPopup401', true);
					} else {
						this.alertMsg = this.errorMsg(error);
						this.alertActivate = true;
					}
				});
			} else {
				this.onload = true;
			}
		},

		getItem(careInsuranceConfirmId) {
			if(!careInsuranceConfirmId) return;

			axios.get(`${api.careInsuranceConfirms}/${careInsuranceConfirmId}`)
			.then(({data}) => {
				this.item = data.data;
				this.popupActivate = true;
			})
			.catch((error) => {
				this.$store.commit('SET_ALERT', { 
					show: true,
					content: this.errorMsg(error),
				});
			})
		},

		

		popupOpen(open, idx) {

			if(open) {

				let prod = this.prodsUsed.items[idx];
				this.item.id = prod.id;
				this.item.date_approval = prod.used.date;
				this.item.price_with_vat = Const.getPriceAddVatRound(prod.used.unit);
				this.item.dealer_title = this.DEALER_AGENT_CDKS[prod.used.dealer_agent_cdk_slug].title;

				if(prod.used.care_insurance_confirm_id) this.item.id = prod.used.care_insurance_confirm_id;
			} else {
				this.item.date_approval = '';
				this.item.price_with_vat = '';
				this.item.dealer_title = '';
			}

			this.popupActivate = open;
		},

		downloadPOAPdf() {
			if(!this.item && !this.item.id) return;

			axios({
				url: `${api.careInsuranceConfirms}/downloadPOAPdf/${this.item.id}`,
				method: 'GET',
				responseType: 'blob', // important
			})
			.then(res => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'BMW ServiceCare+.pdf');
				document.body.appendChild(link);
				link.click();
			})
			.catch(error => {
				this.$store.commit('SET_ALERT', { 
					show: true,
					content: this.errorMsg(error),
				});
			});
		},

	},
}
</script>

<style scoped>

</style>